/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from "@mui/icons-material/Tune";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

import RestartAltIcon from "@mui/icons-material/RestartAlt";

import GroupHierarchy from "./GroupHierarchy";
import "./GroupHierarchy.scss";
import "./TenantUserPage.scss";
import "../TenantPage/FilterOptions.scss";
import {
  Accordion,
  AccordionItem,
  FilterIcon,
  Label,
  Checkbox as ForgeCommonCheckbox,
  Button as ForgeCommonButton,
  CloseIcon as ForgeCommonCloseIcon,
} from "@forge/common";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../localization/keys";

type Anchor = "top" | "left" | "bottom" | "filter";

export default function TemporaryDrawerforUser({
  isFilterDisabled,
  filteringGroup,
  onFilteringCriteriaChange,
  hierarchicalOrganizationwKey,
  comp,
}: {
  isFilterDisabled?: boolean;
  filteringGroup: any;
  onFilteringCriteriaChange: any;
  hierarchicalOrganizationwKey?: any;
  comp?: any;
}) {
  const [t] = useTranslation();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    filter: false,
  });

  const [selectedOptions, setSelectedOptions] = useState<Array<string>>(
    filteringGroup.roles
  );
  const [selectedFilterOptions, setSelectedFilterOptions] =
    useState<any>(filteringGroup);
  const [clearFilter, setClearFilter] = useState<boolean>(false);

  const ListofRoles = useSelector(
    (state: RootState) => state.user.rolestoFilterTenants
  );

  //on change of user filter
  // istanbul ignore next
  const handleCheckboxChange = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
      setSelectedFilterOptions({
        ...selectedFilterOptions,
        roles: selectedOptions.filter((item) => item !== option),
      });
    } else {
      setSelectedOptions([...selectedOptions, option]);
      setSelectedFilterOptions({
        ...selectedFilterOptions,
        roles: [...selectedOptions, option],
      });
    }
  };

  //on cancel of filter tab
  // istanbul ignore next
  const handleCancel = () => {
    setSelectedOptions(filteringGroup.roles);
    setSelectedFilterOptions(filteringGroup);
    setState({ top: false, left: false, bottom: false, filter: false });
  };

  //on clear of user filter
  // istanbul ignore next
  const handleClear = () => {
    setSelectedOptions([]);
    setSelectedFilterOptions({ orgs: [], roles: [] });
    setClearFilter(true);
  };

  //on submit of submit
  // istanbul ignore next
  const handleSubmit = () => {
    // event.preventDefault();
    onFilteringCriteriaChange(selectedFilterOptions);
    setState({ ...state, filter: false });
  };

  const toggleDrawer = (anchor: Anchor, open: boolean) => () => {
    setState({ ...state, [anchor]: open, filter: true });
  };

  // Set selectedOptions to filteringCriteria whenever filteringCriteria changes
  useEffect(() => {
    setSelectedOptions(filteringGroup.roles);
    setSelectedFilterOptions(filteringGroup);
    setClearFilter(false);
  }, [filteringGroup]);

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    ></Box>
  );

  return (
    <div>
      {(["filter"] as const).map((anchor) => (
        <div key={anchor}>
          <ForgeCommonButton
            disabled={isFilterDisabled}
            data-testid="filterbtn"
            icon={<FilterIcon strokeWidth={2} />}
            // iconPosition="left"
            label={t(localeKeyMap.filter)}
            // className="filter-Icon"
            onClick={toggleDrawer(anchor, true)}
            size="regular"
            variant="tertiary"
            aria-label="filter"
          />
          <Drawer
            anchor={"right"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            variant="temporary"
          >
            <div className="header-Filter">
              <Label className="p-l10 m-b0 p-b0">{t(localeKeyMap.filter)}</Label>
              {/* // Close Icon */}
              <ForgeCommonButton
                icon={<ForgeCommonCloseIcon strokeWidth={2} />}
                iconPosition="left"
                label={t(localeKeyMap.close)}
                onClick={handleCancel}
                data-testid="handleCancel_Close"
                size="regular"
                variant="quiet-secondary"
                className="forgeCommonIconBtn"
                aria-label="Close"
              />
            </div>

            <div className="header-Filter">
              <Label className="p-l10 p-b0 m-b0">{t(localeKeyMap.filterBy)} </Label>

              <ForgeCommonButton
                variant="quiet-primary"
                className="p-l10"
                data-testid="handleClearButton"
                onClick={handleClear}
                icon={<RestartAltIcon />}
                aria-label="Clear all"
              >
                {t(localeKeyMap.clearAll)}
              </ForgeCommonButton>
            </div>
            <Accordion id="OrgsRoles" defaultOpenIndex={[1]} multi={true}>
              <AccordionItem id="Orgs" title={t(localeKeyMap.organizations)} data-testid="Organisations">
                <div className="roleDiv">
                  <GroupHierarchy
                    hierarchicalOrganizationwKey={hierarchicalOrganizationwKey}
                    selectedKeyLsit={filteringGroup.orgs}
                    clearFilter={clearFilter}
                    groupFilter={(e: any) => {
                      setClearFilter(false);
                      setSelectedFilterOptions({
                        ...selectedFilterOptions,
                        orgs: e,
                      });
                    }}
                    comp={comp}
                  />
                </div>
              </AccordionItem>
              <AccordionItem id="Roles" title={t(localeKeyMap.roles)} data-testid="Roles">
                <div className="roleDiv">
                  {ListofRoles?.map((option: any) => (
                    <div key={option?.role?.name} className="optionsCheck">
                      <ForgeCommonCheckbox
                        id={`checkbox-roles-${option?.role?.name}`}
                        checked={selectedOptions.includes(option?.role?.name)}
                        onChange={() =>
                          handleCheckboxChange(option?.role?.name)
                        }
                        className="Check"
                        data-testid={`checkbox-roles-${option?.role?.name}`}
                      />
                      <div style={{ marginLeft: ".5rem" }}>
                        {option?.role?.name} {"("} {option?.count} {")"}
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionItem>
            </Accordion>

            <div className="footer-filter-user-popup p-5">
              <ForgeCommonButton
                data-testid="handleCancelButton"
                onClick={handleCancel}
                variant="quiet-primary"
              >
                {t(localeKeyMap.cancel)}
              </ForgeCommonButton>

              <ForgeCommonButton
                data-testid="submit_btn"
                onClick={handleSubmit}
              >
                {t(localeKeyMap.showResults)}
              </ForgeCommonButton>
            </div>

            {list(anchor)}
          </Drawer>
        </div>
      ))}
    </div>
  );
}
